import { BrowserRouter as Router } from "react-router-dom";
import { GlobalDataProvider } from "providers";
import { AppRoutes } from "routes";

function App() {
  return (
    <Router>
      <GlobalDataProvider>
        <AppRoutes />
      </GlobalDataProvider>
    </Router>
  );
}

export default App;
